import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CContainer, CRow, CCol } from '@coreui/react';

function TermsPage() {
    const navigate = useNavigate();
    const navigateAndScroll = (path) => {
      navigate(path);
      window.scrollTo(0, 0);
    };
    const [screenSizeStyles, setScreenSizeStyles] = useState({});

    useEffect(() => {
        const handleResize = () => {
            const newStyles = window.innerWidth <= 768 ? styles.spacingPhone : styles.spacing;
            setScreenSizeStyles(newStyles);
        };

        handleResize(); 

        window.addEventListener('resize', handleResize); 

        return () => {
            window.removeEventListener('resize', handleResize); 
        };
    }, []); 

    const styles = {
        spacing: {
          marginLeft: "30%",
          marginRight: "30%",
        },
        spacingPhone: {
          marginLeft: "5%",
          marginRight: "5%",
        }
    }

    return (
        <div>
        <CCol 
        className="justify-content-center text-center my-5"
        style={screenSizeStyles}
        >
          <h1
            className="display-4"
            style={{
              marginBottom: "3%",
              color: 'black', fontSize: '30px', fontWeight: 'bold'
            }}
          >
            Terms
          </h1>
            <ul className='text-start'>
                <li>As a hotel guest, your contract is with the hotel. You are required to follow hotel rules and are able to use any applicable hotel guest facilities, such as the hotel swimming pool.</li>
                <li>Up to 2 guests are included in the rate. This is the maximum number of guests permitted in a standard room. A child counts as a guest.</li>
                <li>On check-in, the hotel will require photo ID (Drivers Licence or Passport) and a physical credit card for preauthorisation and/or payment of up to one night plus any incidentals (per hotel policies).</li>
                <li><span className="fw-bold">IMPORTANT:</span> If you check-out after one hour and/or use the bedding, including sitting on the bed, you will be subject to the full overnight room rate on the hotel’s website. In this instance the hotel may allow you to check-out the next day. This is at the hotel's discretion and subject to availability.</li>
                <li>All payments are collected by the hotel and, per hotel policies, may attract a payment processing fee. Any refunds may also refund any processing fee.</li>
                <li>There are no cancellation fees. Should you wish to cancel or amend your reservation, please contact us (<span 
                    style={{
                        color: '#009494', 
                        textDecoration: 'underline',
                        cursor: 'pointer'
                    }}onClick={() => navigateAndScroll("/Contact")}>Shower Away</span>) as soon as possible.</li>
            </ul>
        </CCol>
      
      <CCol 
      className="justify-content-center text-center my-5"
      style={screenSizeStyles}>
          <h1
            className="display-4"
            style={{
              marginBottom: "3%",
              color: 'black', fontSize: '30px', fontWeight: 'bold'
            }}
          >
            Privacy Policy
          </h1>
            <p className='text-start'>
            Shower Away collects reservation details on behalf of the hotel to streamline your check-in.
             We will seek your feedback following your Shower Away experience, to improve our service to you. 
             Shower Away follows the Australian Privacy Principles and will never share or sell your details with any third-party without your permission.
            </p>
        </CCol>
      </div>
    );
}

export default TermsPage;
